import React from 'react';
import BrandLogo from '../components/BrandLogo';
import LoginForm from '../components/LoginForm';
import '../styles/AuthPage.css';

const LoginPage = () => (
    <div className="sc-auth-page">
        <div className="sc-auth-card">
            <header className="auth-header">
                <BrandLogo className="sc-auth-logo" />
                <div className="auth-header-text">
                    <h1>Welcome back</h1>
                    <p>Sign in with your email or username</p>
                </div>
            </header>
            <div className="auth-body">
                <LoginForm />
            </div>
        </div>
    </div>
);

export default LoginPage;
